module.exports = __webpack_public_path__ + "media/img/description/description-sevices-bottom-b0b736e65508a2773221b21cd922c877.svg";